export const EVENT_TYPE = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL',
  HYBRID: 'HYBRID',
};
